import { useContext } from "react";

import { LoadImageWithPriorityContext } from "src/context/LoadImageWithPriorityContext/LoadImageWithPriorityContext";

export const useLoadImageWithPriorityContext = () => {
  const value = useContext(LoadImageWithPriorityContext);

  return value?.ids?.length > 0 ? value.ids : [];
};
